import { BRAND } from '../config/brand';

export const RAMS_DISCLAIMER = `DISCLAIMER

This document is a draft template provided for guidance purposes only and does not constitute professional health and safety advice.

The user is solely responsible for ensuring that all risk assessments and method statements are suitable, sufficient, site-specific, and compliant with applicable legislation including the Health and Safety at Work etc. Act 1974 and CDM Regulations 2015.

Users must review, amend, and verify all content prior to use.

${BRAND.legalEntity} (trading as ${BRAND.name}) accepts no liability for loss, injury, damage, prosecution, or non-compliance arising from use of this template.

${BRAND.legalEntity} · Company no. ${BRAND.companyNumber} · Registered in ${BRAND.companyJurisdiction} · ${BRAND.registeredOffice}`;

export const TERMS_VERSION = '1.0';
export const TERMS_LAST_UPDATED = '16 May 2026';

export const PRIVACY_VERSION = '1.0';
export const PRIVACY_LAST_UPDATED = '11 May 2026';
